import * as React from 'react';
import * as S from './CardError.styles';

interface CardErrorProps {
  texts: (string | JSX.Element)[];
  icon?: JSX.Element;
  forceHeight?: boolean;
  disabled?: boolean;
}

export const CardError: React.FunctionComponent<CardErrorProps> = ({
  icon,
  texts,
  forceHeight = true,
  disabled = false
}) => {
  return (
    <>
      {forceHeight ? <S.Backface /> : null}
      <S.Container $disabled={disabled}>
        {icon ? <div data-testid="icon">{icon}</div> : null}
        {texts.map((text, index) => (
          <S.TextBlock
            as={typeof text === 'string' ? 'p' : 'div'}
            key={index}
          >
            {text}
          </S.TextBlock>
        ))}
      </S.Container>
    </>
  );
};
